import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../../shared/store";

export const useAuthGuard = () => {
  const token = useAuthStore((s) => s.token);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    console.log("useAuthGuard check", { token, pathname });

    if (token && pathname === "/login") {
      navigate("/", { replace: true });
    } else if (!token && pathname !== "/login") {
      navigate("/login", {
        replace: true,
        state: { from: { pathname } },
      });
    }
  }, [token, navigate, pathname]);
};